var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.92 30A15.58 15.58 0 0129 26.43 1.46 1.46 0 0030.31 25V11.17a1.48 1.48 0 00-1.48-1.48h-.2a15.63 15.63 0 00-7.71 3.52 1.53 1.53 0 01-1.84 0 15.59 15.59 0 00-7.71-3.51 1.45 1.45 0 00-1.68 1.47V25A1.46 1.46 0 0011 26.43 15.58 15.58 0 0119.08 30a1.5 1.5 0 001.84 0zM20 13.53v16.78"
  }))));
}
export default SvgStreamlineBook;